import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const TopBar = () =>{
  const navigate = useNavigate();
  const onLogout =()=> {
    localStorage.removeItem("userDetails");
    navigate("/");
   
  }
  
  return (
  <header className="main-header">
      <Link to="/dashboard" className="logo">
        {/* Logo */}
        <span className="logo-mini">
          <img src="assets/dist/img/mini-logo.png" alt="mini logo" />
        </span>
        <span className="logo-lg">
          <img src="assets/dist/img/logo.png" alt="logo" />
        </span>
      </Link>

      {/* Header Navbar */}
      <nav className="navbar navbar-expand py-0">
        <a
          href="#"
          className="sidebar-toggle"
          data-toggle="offcanvas"
          role="button"
        >
          <span className="sr-only">Toggle navigation</span>
          <span className="pe-7s-angle-left-circle" />
        </a>

        <div className="collapse navbar-collapse navbar-custom-menu">
          <ul className="navbar-nav ml-auto">
            {/* User */}
            <li className="nav-item dropdown dropdown-user">
              <a
                className="nav-link"
                href="#"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  src="assets/dist/img/avatar5.png"
                  className="rounded-circle"
                  width="50"
                  height="50"
                  alt="user"
                />
              </a>

              <div className="dropdown-menu drop_down">
                <div className="menus">
                  <Link className="dropdown-item" to="/profile">
                    <i className="fa fa-user" /> User Profile
                  </Link>
                  <a
                    className="dropdown-item"
                    href="#"
                    data-toggle="modal"
                    data-target="#logout"
                    onClick={onLogout}
                  >
                    <i className="fa fa-sign-out" /> Signout
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </header>
)};

export default TopBar;
